<template>
    <div>
      <h1 style="vertical-align: middle;text-align: center;font-size: 78px;margin-top: 20% ">Coming Soon</h1>
    </div>
</template>

<script>
export default {
  name: 'coming'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/coming.vue